import { useEffect, useState } from "react";
import client from "./api";

// Module-level cache so all demo panes share ONE fetch per language.
const cache = new Map();
const EMPTY = { onboarding: [], fullsuite: [], sections: [], me_section: "", ui: {}, pane: {}, labels: {} };

export function useDemoI18n(lang) {
  const [data, setData] = useState(lang === "ENG" ? EMPTY : (cache.get(lang) || EMPTY));
  useEffect(() => {
    if (!lang || lang === "ENG") { setData(EMPTY); return; }
    if (cache.has(lang)) { setData(cache.get(lang)); return; }
    let alive = true;
    client.get("/site/demo-i18n", { params: { lang } })
      .then((r) => { cache.set(lang, r.data); if (alive) setData(r.data); })
      .catch(() => { if (alive) setData(EMPTY); });
    return () => { alive = false; };
  }, [lang]);
  return data;
}
